export default {
  private: false,
  template_name: 'Dropdown',
  allowed_types: [
    'gh_element'
  ],
  model: {
    template_id: 'gh_dropdown',
    name: 'Dropdown',
    icon_id: 'dropdown',
    class: 'gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll gh_col_width_0',
    priority: 0,
    container_id: 0,
    content: [
      {allowed_types: ['gh_element'], template_id: 'gh_float', name: '', icon_id: '', class: '', priority: 0, container_id: 0, content: []}
    ]
  },
  html:
    /*html */`
    <div class="gh_dropdown" ng-init="lists = item.content;">
      <div class="dropdown_wrapper" ng-click="opened = !opened;" ng-class="{opened: opened}">

      <span class="gh_tabs_block_nav_btn_icon" gh-icon="{{item.icon_id ? item.icon_id : 'box'}} 0D99FF 30px normal"></span>
      <span class="gh_dropdown_name">{{item.name}}</span>
      <span class="caret" gh-icon="bot_arrow 7f7f7f 15px normal"></span>

      <div class="dropdown_elements">
        <div class="drag_placeholder" ng-show="!item.content[0].content.length">
          <span> Drag Element </span>
        </div>
        <div ng-class="item.class" class="container_wrapper" ng-repeat="item in lists" ng-include="item.template_id + '_editor_light'"></div>
      </div>
      </div>
    </div>
    `,
  icon: 'dropdown'
};
